import { IPartnerFinSobRow } from '../../model'

import { findGrowthValue } from './findGrowthValue'
import { getActualsRows } from './getActualsRows'
import { IRevenueAndSobFigures, TCategoryRowScope } from './types'

interface IParams {
  rows: IPartnerFinSobRow[]
  selectedFYear: number
  category?: string
  categoryRowScope?: TCategoryRowScope
}

/** The tile's market growth benchmark: the market-wide YoY growth rate the API attaches to a
 *  category's current-year rows (`finYoyGrowth`/`sobYoyGrowth`). Callers pass actuals and target
 *  rows together — a plan year has no actuals yet, so its target rows are the only ones carrying the
 *  rate. See `findGrowthValue` for why the first non-null value is taken rather than summed or
 *  weighted. */
export const getRevenueAndSobMarketGrowth = ({
  rows,
  selectedFYear,
  category,
  categoryRowScope,
}: IParams): IRevenueAndSobFigures => {
  const actualsRows = getActualsRows({ rows, selectedFYear, category, categoryRowScope })

  return {
    sales: findGrowthValue(actualsRows, 'finYoyGrowth'),
    sob: findGrowthValue(actualsRows, 'sobYoyGrowth'),
  }
}
